import styled from "styled-components";
import { animated } from "react-spring";
import * as Visibility from "react-visibility-sensor";

export const RevealOnScroll = styled(Visibility.default)``;

export const RevealOnScrollChildren = styled(animated.div)``;
